/** @jsxImportSource @emotion/react */
import { css } from '@emotion/react'
import { Add } from '@mui/icons-material'
import { Button, Dialog, DialogActions, DialogContent, DialogTitle } from '@mui/material'
import { useState } from 'react'
import { useTranslation } from 'react-i18next'
import { getMobileMediaQuery } from '../../app/material-ui/material-ui.config'
import { dispatchSubmit } from '../../utils/forms-utils'
import { QueryStatusView } from '../general/query-status.view'
import { useCreateDepartmentMutation } from '../../redux/apis/companies-api'
import { CompanyForm } from './company-form'
import { DepartmentCreateRequest } from './models/company'
import StyledContainedButton from '../styled/styled-contained-button'
import { useAuthContext } from '../auth/auth.slice'
export const ADD_NEW_DEPARTMENT_FORM_ID = 'ADD_NEW_DEPARTMENT_FORM_ID'

type Props = {
    companyId?: string
}

export const AddDepartment: React.FC<Props> = ({ companyId }) => {
    const { t } = useTranslation()
    const [isOpen, setOpen] = useState(false)
    const context = useAuthContext()

    const [create, { isLoading, error, isError }] = useCreateDepartmentMutation()
    const onSubmit = (values: DepartmentCreateRequest) => {
        if (!isLoading) {
            create({ ...values, parentId: companyId ?? context?.entityId ?? '' })
                .unwrap()
                .then(() => setOpen(false))
        }
    }
    const styles = {
        addButton: css`
            box-shadow: 1px 1px 3px 0 rgba(0, 0, 0, 0.15);
            @media ${getMobileMediaQuery()} {
                margin-left: 16px;
            }
        `,
        wrapper: css`
            padding: 16px;
        `,
    }
    return (
        <div css={styles.wrapper}>
            <StyledContainedButton
                disableElevation
                css={styles.addButton}
                startIcon={<Add />}
                color={'secondary'}
                variant={'contained'}
                onClick={() => setOpen(true)}
            >
                {t('TEXT_ADD_DEPARTMENT', 'Legg til ny avdeling')}
            </StyledContainedButton>
            <Dialog open={isOpen} onClose={() => setOpen(false)} fullWidth={true} maxWidth={'sm'}>
                <DialogTitle>{t('TEXT_ADD_DEPARTMENT_TITLE', 'Legg til ny avdeling')}</DialogTitle>
                <DialogContent>
                    <CompanyForm id={ADD_NEW_DEPARTMENT_FORM_ID} onSubmit={onSubmit} />
                    <QueryStatusView error={error} isError={isError} />
                </DialogContent>
                <DialogActions>
                    <Button onClick={() => setOpen(false)}>{t('TEXT_CANCEL', 'AVBRYT')}</Button>
                    <StyledContainedButton
                        disabled={isLoading}
                        variant={'contained'}
                        color={'secondary'}
                        onClick={() => dispatchSubmit(ADD_NEW_DEPARTMENT_FORM_ID)}
                    >
                        {t('TEXT_SAVE', 'LAGRE')}
                    </StyledContainedButton>
                </DialogActions>
            </Dialog>
        </div>
    )
}
